import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DashboardLayout } from "../common/page_component/index.js";
import Loader from "../common/Loader.js";
import Alert from "../common/Alert.js";
import Button from "../common/Button.js";
import agentPartnershipService from "../../services/agentPartnershipService.js";
import { useAuth } from "../../context/AuthContext.js";
import isExternalNetworkEnabled from "../../utils/networkMode.js";
import { useTranslation } from 'react-i18next';


const PartnershipRequests = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [requests, setRequests] = useState([]);

  useEffect(() => {
    if (!isExternalNetworkEnabled(user)) {
      navigate("/admin-dashboard");
      return;
    }
    fetchRequests();
  }, [user]);

  const fetchRequests = async () => {
    try {
      setLoading(true);
      const response = await agentPartnershipService.list({ scope: "outgoing" });
      setRequests(response.data?.data || []);
    } catch (error) {
      Alert.error(error.response?.data?.error || "Failed to load requests");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <DashboardLayout><Loader /></DashboardLayout>;

  return (
    <DashboardLayout>
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <h1 className="text-xl font-semibold">{t('pages.agentNetwork.requests')}</h1>
          <Button variant="secondary" onClick={() => navigate("/partner-agents")}>Back</Button>
        </div>
        <div className="overflow-x-auto rounded-lg border bg-white">
          <table className="min-w-full text-sm">
            <thead className="bg-gray-50 text-left">
              <tr>
                <th className="px-4 py-3">Agent</th>
                <th className="px-4 py-3">City</th>
                <th className="px-4 py-3">Status</th>
                <th className="px-4 py-3">Requested</th>
              </tr>
            </thead>
            <tbody>
              {requests.length === 0 ? (
                <tr><td colSpan="4" className="px-4 py-6 text-center text-gray-500">No requests found</td></tr>
              ) : requests.map((item) => (
                <tr key={item.partnership_id} className="border-t">
                  <td className="px-4 py-3">{item.agent_name}</td>
                  <td className="px-4 py-3">{item.service_city}</td>
                  <td className="px-4 py-3 capitalize">{item.status}</td>
                  <td className="px-4 py-3">{item.requested_at ? new Date(item.requested_at).toLocaleDateString() : "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default PartnershipRequests;
